export const ActionTypes = {
  ALL_REQUESTS_FETCH_DATA: "ALL_REQUESTS_FETCH_DATA",
  ALL_REQUESTS_FETCH_DATA_SUCCESS: "ALL_REQUESTS_FETCH_DATA_SUCCESS",
  ALL_REQUESTS_SET_FETCH_DATA: "ALL_REQUESTS_SET_FETCH_DATA",
  ALL_REQUESTS_SET_USER_DETAILS: "ALL_REQUESTS_SET_USER_DETAILS",
};

export const GET_POSTS: string = `/posts`;
